import { styled } from '@mui/material/styles';
import { Card, Paper, Button, TextField } from '@mui/material';

// Modern card with consistent styling
export const ModernCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  border: `1px solid ${theme.palette.divider}`,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
  },
}));

// Gradient button component
export const GradientButton = styled(Button)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
  color: 'white',
  fontWeight: 600,
  textTransform: 'none',
  borderRadius: 8,
  padding: '12px 24px',
  '&:hover': {
    background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
    transform: 'translateY(-1px)',
    boxShadow: `0 6px 20px ${theme.palette.primary.main}40`,
  },
  '&:disabled': {
    background: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
  transition: 'all 0.2s ease-in-out',
}));

// Page container with consistent padding and background
export const PageContainer = styled('div')(({ theme }) => ({
  minHeight: 'calc(100vh - 72px)', // Subtract header height
  background: theme.palette.background.default,
  padding: theme.spacing(3, 2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 3),
  },
}));

// Form paper component
export const FormPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: 16,
  border: `1px solid ${theme.palette.divider}`,
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  },
}));

// Statistics card for dashboards
export const StatsCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 16,
  border: `1px solid ${theme.palette.divider}`,
  textAlign: 'center',
  background: theme.palette.background.paper,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
  },
}));

// Enhanced text field with modern styling
export const ModernTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    transition: 'all 0.2s ease-in-out',
    '& fieldset': {
      borderColor: theme.palette.divider,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
    '&.Mui-focused': {
      transform: 'scale(1.01)',
    },
  },
  '& .MuiInputLabel-root': {
    fontWeight: 500,
  },
}));

// Section header component
export const SectionHeader = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(3),
  '& .MuiTypography-root': {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
}));

// Action buttons container
export const ActionButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'flex-end',
  marginTop: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    '& > *': {
      width: '100%',
    },
  },
}));

const styledComponents = {
  ModernCard,
  GradientButton,
  PageContainer,
  FormPaper,
  StatsCard,
  ModernTextField,
  SectionHeader,
  ActionButtonsContainer,
};

export default styledComponents; 